import React, { useCallback, useEffect } from 'react';
import { Line, Contract, Infos, Value } from './styles';
import Modal from '../index';
import { navigationUrl } from '../../../store/analytic/actions';
import { useDispatch } from 'react-redux';
import getOriginalContract from '../../../utils/getOriginalContract';
import getContractDescription from '../../../utils/getContractDescription';
import Accordion from '../../Accordion';

interface IContract {
  handlerClose: () => void;
  // contracts: (string | GQL.IContractDetails)[];
  contracts: any;
}

function Contracts({ handlerClose, contracts }: IContract) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/listagemContratos',
      })
    );
  }, [dispatch]);
  return (
    <Modal title={'Contratos'} handlerClose={handlerClose}>
      {contracts &&
        contracts.length > 0 &&
        contracts.map((contract: any, index: number) => {
          return (
            <Contract key={index}>
              <Accordion
                title={contract.originalContract || contract.contract}
                subtitle={' ' && (contract.descriptionProduct ?? '-')}
                hasParcel={contract.originalContractInstallments.length > 0}
              >
                {contract.originalContractInstallments.length > 0 &&
                  contract.originalContractInstallments.map(
                    (contractDetail: any, detailIndex: number) => (
                      <div key={detailIndex}>
                        <Infos>
                          <div>Identificador: {contractDetail.number}</div>
                          Vencimento: {contractDetail.formattedDueDate}
                        </Infos>

                        <Value>Valor: R$ {contractDetail.mainValue}</Value>
                        <Line />
                      </div>
                    )
                  )}
              </Accordion>

              {/* <span>{getOriginalContract(contract)}</span>
              {getContractDescription(contract) ? (
                <p className='description'>
                  {getContractDescription(contract)}
                </p>
              ) : (
                <></>
              )} */}
            </Contract>
          );
        })}
    </Modal>
  );
}

export default Contracts;
